// Restore each workspace/filter list's scroll position only when its cached or loaded rows are ready.
import { useEffect } from 'react';
const positions = new Map<string, number>();
export function useListPosition(key: string, ready: boolean) {
  useEffect(() => {
    if (!ready) return;
    const frame = requestAnimationFrame(() => window.scrollTo({ top: positions.get(key) ?? 0 }));
    const remember = () => { if (document.body.style.position !== 'fixed') positions.set(key, window.scrollY); };
    window.addEventListener('scroll', remember, { passive: true });
    return () => { cancelAnimationFrame(frame); window.removeEventListener('scroll', remember); };
  }, [key, ready]);
}
